var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ion:location",
    filter: "url(#filter0_d_102_1118)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.25 6C15.8039 6 13 8.68164 13 11.9766C13 13.5457 13.7152 15.6324 15.1258 18.1789C16.2586 20.2234 17.5691 22.0723 18.2508 22.9922C18.366 23.1494 18.5166 23.2772 18.6904 23.3653C18.8642 23.4534 19.0563 23.4993 19.2512 23.4993C19.446 23.4993 19.6382 23.4534 19.812 23.3653C19.9858 23.2772 20.1364 23.1494 20.2516 22.9922C20.932 22.0723 22.2438 20.2234 23.3766 18.1789C24.7848 15.6332 25.5 13.5465 25.5 11.9766C25.5 8.68164 22.6961 6 19.25 6ZM19.25 14.75C18.7555 14.75 18.2722 14.6034 17.8611 14.3287C17.45 14.054 17.1295 13.6635 16.9403 13.2067C16.7511 12.7499 16.7016 12.2472 16.798 11.7623C16.8945 11.2773 17.1326 10.8319 17.4822 10.4822C17.8319 10.1326 18.2773 9.8945 18.7623 9.79804C19.2472 9.70157 19.7499 9.75108 20.2067 9.9403C20.6635 10.1295 21.054 10.45 21.3287 10.8611C21.6034 11.2722 21.75 11.7555 21.75 12.25C21.7493 12.9128 21.4857 13.5483 21.017 14.017C20.5483 14.4857 19.9128 14.7493 19.25 14.75Z",
    fill: "#0D4672"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_102_1118",
    x: 0,
    y: 0,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_1118"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_102_1118",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.703ade43a86d6306b5a409be62ea4822.svg";
export { ForwardRef as ReactComponent };